import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            padding: 2px 4px;\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        align-items: flex-start;\n        font-family: ", ";\n        color: ", ";\n        display: flex;\n        position: relative;\n        /* Content box changes intended size of the input */\n        box-sizing: border-box;\n        &[data-disabled] {\n          color: ", ";\n          cursor: not-allowed;\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { forwardRef, memo, useMemo } from 'react';
import { css, jsx } from '@emotion/core';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import { DN600, N80, N900 } from '@atlaskit/theme/colors';
import GlobalTheme from '@atlaskit/theme/components';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
import getRadioStyles from './styles';
import { name as packageName, version as packageVersion } from './version.json';
var fontFamily = getFontFamily();

var noop = function noop() {};

var RadioWithMode = /*#__PURE__*/forwardRef(function Radio(props, ref) {
  var ariaLabel = props.ariaLabel,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      isRequired = props.isRequired,
      _props$isInvalid = props.isInvalid,
      isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
      _props$isChecked = props.isChecked,
      isChecked = _props$isChecked === void 0 ? false : _props$isChecked,
      label = props.label,
      mode = props.mode,
      name = props.name,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? noop : _props$onChange,
      value = props.value,
      testId = props.testId,
      analyticsContext = props.analyticsContext,
      rest = _objectWithoutProperties(props, ["ariaLabel", "isDisabled", "isRequired", "isInvalid", "isChecked", "label", "mode", "name", "onChange", "value", "testId", "analyticsContext"]);

  var onChangeAnalytics = usePlatformLeafEventHandler({
    fn: onChange,
    action: 'changed',
    analyticsData: analyticsContext,
    componentName: 'radio',
    packageName: packageName,
    packageVersion: packageVersion
  });
  var styles = useMemo(function () {
    return getRadioStyles(mode);
  }, [mode]);
  return jsx("label", {
    "data-testid": testId && "".concat(testId, "--radio-label"),
    "data-disabled": isDisabled ? 'true' : undefined,
    css: css(_templateObject(), fontFamily, mode === 'light' ? N900 : DN600, N80)
  }, jsx("input", _extends({}, rest, {
    "aria-label": ariaLabel,
    checked: isChecked,
    disabled: isDisabled,
    name: name,
    onChange: onChangeAnalytics,
    required: isRequired,
    type: "radio",
    value: value,
    "data-testid": testId && "".concat(testId, "--radio-input") // isInvalid is used in a nonstandard way so cannot
    // use :invalid selector
    ,
    "data-invalid": isInvalid ? 'true' : undefined,
    css: styles,
    ref: ref
  })), label ? jsx("span", {
    css: css(_templateObject2())
  }, label) : null);
});
var Radio = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Radio(props, ref) {
  return jsx(GlobalTheme.Consumer, null, function (_ref) {
    var mode = _ref.mode;
    return jsx(RadioWithMode, _extends({}, props, {
      ref: ref,
      mode: mode
    }));
  });
}));
export default Radio;